<template>
  <div class="pix-qr-card">
    <div class="d-flex flex-wrap justify-center mb-4" v-if="hasInfo">
      <v-chip v-if="pix.total_amount" small label color="teal lighten-5" class="ma-1 teal--text text--darken-3">
        <v-icon left small>mdi-currency-brl</v-icon>
        {{ formatMoney(pix.total_amount) }}
      </v-chip>
      <v-chip v-if="isCobranca && pix.due_date" small label color="indigo lighten-5" class="ma-1 indigo--text text--darken-3">
        <v-icon left small>mdi-calendar</v-icon>
        Vence {{ $moment(pix.due_date).utc().format('DD/MM/YYYY') }}
      </v-chip>
      <v-chip v-if="status" small label :color="status.color" class="ma-1 white--text">
        <v-icon left small>{{ status.icon }}</v-icon>
        {{ status.text }}
      </v-chip>
    </div>

    <div class="pix-qr-card__qr mx-auto mb-4" v-if="canShowQr">
      <v-img
        v-if="pix.qr_code && pix.gateway_provider === 'justa'"
        :src="pix.qr_code"
        contain
        max-height="260"
      ></v-img>
      <QrcodeVue
        v-else
        :value="pix.qr_code_text"
        :size="240"
        level="H"
        render-as="svg"
      ></QrcodeVue>
    </div>
    <v-alert v-else type="info" dense text class="mb-4">
      {{ unavailableMessage }}
    </v-alert>

    <template v-if="pix.qr_code_text && isPayable">
      <div class="caption grey--text text--darken-1 mb-1">Pix Copia e Cola</div>
      <div class="pix-qr-card__code mb-3">{{ pix.qr_code_text }}</div>
      <v-btn block depressed color="teal darken-2" class="white--text" @click="copyCode">
        <v-icon left small>{{ copied ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
        {{ copied ? 'Código copiado!' : 'Copiar código Pix' }}
      </v-btn>
    </template>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

const STATUSES = {
  pending: { text: 'Aguardando pagamento', color: 'amber darken-2', icon: 'mdi-clock-outline' },
  pendingv: { text: 'Aguardando pagamento', color: 'amber darken-2', icon: 'mdi-clock-outline' },
  approved: { text: 'Pago', color: 'success', icon: 'mdi-check-circle' },
  cancelled: { text: 'Cancelado', color: 'blue-grey', icon: 'mdi-cancel' },
  expired: { text: 'Expirado', color: 'error', icon: 'mdi-alert-circle' },
  error: { text: 'Erro ao gerar', color: 'error', icon: 'mdi-alert-circle' },
}

export default {
  name: 'PixQrCard',
  components: { QrcodeVue },
  props: {
    pix: { type: Object, required: true },
  },
  data() {
    return { copied: false }
  },
  computed: {
    isCobranca() {
      return this.pix.gateway_provider === 'sicoob_pix_cobranca'
    },
    status() {
      return STATUSES[this.pix.pix_status] || null
    },
    isPayable() {
      return !this.pix.pix_status || ['pending', 'pendingv'].includes(this.pix.pix_status)
    },
    canShowQr() {
      if (!this.isPayable) return false
      if (this.pix.gateway_provider === 'justa') return !!this.pix.qr_code
      return !!this.pix.qr_code_text
    },
    hasInfo() {
      return !!(this.pix.total_amount || this.status || (this.isCobranca && this.pix.due_date))
    },
    unavailableMessage() {
      if (this.pix.pix_status === 'approved') return 'Este Pix já foi pago.'
      if (!this.isPayable) return 'Este Pix não está mais disponível para pagamento.'
      return 'QR code ainda não disponível para este Pix.'
    },
  },
  methods: {
    formatMoney(value) {
      return Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    async copyCode() {
      const text = this.pix.qr_code_text
      try {
        await navigator.clipboard.writeText(text)
      } catch (e) {
        const el = document.createElement('textarea')
        el.value = text
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
      }
      this.copied = true
      setTimeout(() => { this.copied = false }, 2000)
    },
  },
}
</script>

<style scoped>
.pix-qr-card__qr {
  width: fit-content;
  padding: 12px;
  background: #fff;
  border: 1px solid #e8eef3;
  border-radius: 16px;
}
.pix-qr-card__code {
  background: #f7f9fb;
  border: 1px dashed #b0bec5;
  border-radius: 10px;
  padding: 10px 12px;
  font-family: monospace;
  font-size: 12px;
  word-break: break-all;
  max-height: 96px;
  overflow-y: auto;
}
</style>
